import * as React from 'react';
import { getTimePanelDropState } from '../selectors/timePanelDndStoreSelectors';
import { Droppable, DragData } from 'owa-dnd';
import { observer } from 'mobx-react-lite';

export interface CalendarListDropListenerProps {
    children?: React.ReactNode;
}

/**
 * This component handles listening for emails being dragged over the time panel
 * and accordingly modifying the store to show the drop hint.
 */
const CalendarListDropListener: React.FunctionComponent<CalendarListDropListenerProps> = observer(
    function CalendarListDropListener(props: CalendarListDropListenerProps) {
        const { children } = props;

        return (
            <Droppable
                dropViewState={getTimePanelDropState()}
                onDrop={doNothing}
                canDrop={alwaysReturnTrue}
                greedy={true}>
                {children}
            </Droppable>
        );
    }
);

function doNothing(dragInfo: DragData, pageX: number, pageY: number, target?: HTMLElement) {
    return;
}

function alwaysReturnTrue(dragInfo: DragData): boolean {
    return true;
}

export default CalendarListDropListener;
